import * as React from 'react';

const StripeLink = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M6 0.5H52C55.0376 0.5 57.5 2.96243 57.5 6V34C57.5 37.0376 55.0376 39.5 52 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 3.05741 2.81084 0.654222 5.7168 0.506836L6 0.5Z"
      fill="white"
    />
    <path
      d="M6 0.5H52C55.0376 0.5 57.5 2.96243 57.5 6V34C57.5 37.0376 55.0376 39.5 52 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 3.05741 2.81084 0.654222 5.7168 0.506836L6 0.5Z"
      stroke="#F5F5F5"
    />
    <path
      d="M28.9993 15.0803C28.9993 14.4136 29.561 13.8717 30.2221 13.8717C30.8832 13.8717 31.4449 14.4164 31.4449 15.0803C31.4449 15.7442 30.903 16.3032 30.2221 16.3032C29.5412 16.3032 28.9993 15.7613 28.9993 15.0803ZM25.3705 14.0419H27.4984V25.958H25.3705V14.0419ZM31.2974 17.4465H29.1525V25.958H31.2974V17.4465ZM46.7174 21.4129C48.3317 20.4199 49.4297 18.9417 49.8638 17.4437H47.7189C47.16 18.8736 45.8776 19.9489 44.4675 20.4057V14.0391H42.3226V25.9552H44.4675V22.4116C46.1046 22.8201 47.3983 24.2359 47.8409 25.9552H50C49.6709 24.1508 48.4367 22.4626 46.7174 21.4129ZM35.0992 18.3998C35.661 17.6537 36.7561 17.2196 37.6441 17.2196C39.301 17.2196 40.6714 18.431 40.6742 20.261V25.9552H38.5293V20.7348C38.5293 19.983 38.1945 19.1148 37.1079 19.1148C35.8312 19.1148 35.0964 20.2468 35.0964 21.5718V25.9609H32.9515V17.4522H35.0992V18.3998Z"
      fill="black"
    />
    <path
      d="M14.7425 27.0929C18.6598 27.0929 21.8354 23.9173 21.8354 20C21.8354 16.0827 18.6598 12.9071 14.7425 12.9071C10.8252 12.9071 7.6496 16.0827 7.6496 20C7.6496 23.9173 10.8252 27.0929 14.7425 27.0929Z"
      fill="#00D66F"
    />
    <path
      d="M14.4162 15.7443H12.2287C12.6543 17.5232 13.897 19.0439 15.4518 20C13.8941 20.9561 12.6543 22.4768 12.2287 24.2557H14.4162C14.9581 22.6102 16.4589 21.1802 18.3031 20.888V19.1092C16.4561 18.8198 14.9552 17.3898 14.4162 15.7443Z"
      fill="#011E0F"
    />
  </svg>
);

export default StripeLink;
